import _ from 'lodash'
import { FloorMappingEntryType } from '../../../types/Survey/Analysis/Concept'
import useConceptConfiguration from '../../Admin/Survey/Analysis/ConceptCalculation/useConceptConfiguration'
import Dropdown from '../Dropdown/Dropdown'
import { useSelector } from 'react-redux'
import props from '../../../redux/props'

type Props = {
  type: FloorMappingEntryType
  targetUUID: string
  label?: boolean
}

const FloorAssignment: React.FC<Props> = ({ type, targetUUID, label = false }) => {
  const { context, getActiveConcept, updateActiveConcept } = useConceptConfiguration()
  const t = useSelector((s) => s[props.TRANSLATION])

  const getCurrentSelection = () => {
    const concept = getActiveConcept()
    if (!concept?.floorMapping) return null
    const mapping = concept.floorMapping.find((m) => m.type === type && m.targetUUID === targetUUID)
    return mapping?.floorUUID
  }

  const updateValue = (value: string) => {
    const concept = _.cloneDeep(getActiveConcept())
    if (!concept?.floorMapping) {
      concept.floorMapping = []
    }
    const mapping = concept.floorMapping.find((m) => m.type === type && m.targetUUID === targetUUID)
    if (mapping) {
      mapping.floorUUID = value
    } else {
      concept.floorMapping.push({ type, targetUUID, floorUUID: value })
    }
    updateActiveConcept(concept)
  }

  return (
    <div className={`flex ${label ? 'flex-col' : 'gap-5 items-center justify-between'} w-full`}>
      <div className={label ? 'text-xs' : 'font-light text-md text-nowrap'}>{t.survey.analysis.calculation.values.floorAssignment.headline}</div>
      <div className={`${label ? 'w-full' : 'w-1/2'}`}>
        <Dropdown
          value={getCurrentSelection()}
          items={context.floors.map((floor) => ({ value: floor.uuid, label: floor.name }))}
          onChange={updateValue}
        />
      </div>
    </div>
  )
}

export default FloorAssignment
